
//Initializes the global Autodesk namespace, required by GUI and  extensions
//Also exports the Autodesk namespace from the node module for new/future code to use.

// Importing from LMV populates the global namespaces.
const LMV = require("@adsk/lmv");

// Define custom namespaces (this also defines Autodesk.Tandem implicitly).
LMV.av.AutodeskNamespace("Autodesk.Tandem.Extensions"); // Webpack bundled extensions.

// Re-export LMV's scopes. This should be checked from time to time, to adopt new scopes when updating LMV.
// Note that LMV also exports all symbols to the module root.
// We don't re-export this, because everything can (and should) be accessed through the corresponding scope.
module.exports = {
    Autodesk: LMV.Autodesk,
    av: LMV.av,
    ave: LMV.av,
    avm: LMV.av,
    avp: LMV.av,
    avs: LMV.av,
    avu: LMV.av,
    THREE: LMV.THREE,
};

// Register extensions bundled into their own JS files
require("../extensions/registerExternalExtensions");

var _extend = Object.assign || function(target, source) {
    for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
            target[prop] = source[prop];
        }
    }
};

function _export(m, ns) {
    for (var prop in m) {
        if (m.hasOwnProperty(prop)) {
            //Export directly into the module (e.g. for node.js use, where LMV is used via require instead from global namespace)
            module.exports[prop] = m[prop];
            //Export into the desired viewer namespace
            if (ns)
                module.exports[ns][prop] = m[prop];
        }
    }
}

// Tandem API
// TODO: This is just a global namespace for now.
// Should get exported from the module as well in the future.
var dt = LMV.av.AutodeskNamespace("Autodesk.Tandem");

if (BUILD_FLAG__WANT_GUI) {
    // Bundle CSS files into a single one.
    require('./index-css');

    _extend(dt, require("./dt/hud/Label3D"));

    _extend(dt, require("./dt/DtGuiViewer3D"));
}

// TODO: We can probably clean this up.
// Remove everything that we don't want to expose from the SDK.
_extend(dt, require("./dt/DtViewer3D"));
_extend(dt, require("./dt/DtViewer3DImpl"));
_extend(dt, require("./dt/DtModelLMV"));
_extend(dt, require("./dt/DtApp"));
_extend(dt, require("./dt/DtEventTypes"));
_extend(dt, require("./dt/DtFacility"));
_extend(dt, require("./dt/DtViewerState"));
_extend(dt, require("./dt/DtTeam"));
_extend(dt, require("./dt/DtUser"));
_extend(dt, require("./dt/DtViews"));
_extend(dt, require("./net/fetch"));
_extend(dt, require("./net/DtWebSocket"));
_extend(dt, require("./dt/encoding/base64"));

_extend(dt, require("./dt/schema/DtConstants"));
_extend(dt, require("./dt/schema/system-class"));
_extend(dt, require("./dt/facets/Facets"));
_extend(dt, require("./dt/facets/FacetsManager"));
_extend(dt, require("./dt/facets/clustering"));
_extend(dt, require("./dt/facets/theming"));
_extend(dt, require("./dt/facets/ColorUtils"));
_extend(dt, require("./dt/loader/DtLoader"));
_extend(dt, require("./dt/schema/Attribute"));
_extend(dt, require("./dt/DtWorkerCreator"));
_extend(dt, require("./dt/connectivity/ConnectivityUtils"));
_extend(dt, require("./dt/connectivity/TracePaths"));
_extend(dt, require("./dt/utils/SystemBitMask"));
_extend(dt, require("./dt/schema/DtKeysEnumerator"));
_extend(dt, require("./dt/schema/TandemCategories"));
_extend(dt, require("./dt/schema/AssetCheck"));

_extend(dt, require("./dt/search/Search"));

_extend(dt, require("./dt/streams/StreamUtils"));

_extend(dt, require("./dt/preferences/DtPreferenceNames"));
_extend(dt, require("./dt/preferences/DtProfile"));

_extend(dt, require("./dt/gui/controlsHelper"));

// DT exports that replace / extend LMV, i.e. files that are (modified) copies from LMV.
// TODO-LMV: Clean these files up to only keep what has been added / changed.
_extend(dt, require("./compat")); // TODO: Only keep the WebGPU checks.
_extend(dt, require("./envinit"));
_extend(dt, require("./globals"));
_extend(dt, require("./net/endpoints"));

_extend(dt, require('./lmv-compat/measurement/UnitFormatter'));
_extend(dt, require("./lmv-compat/DtEventUtils"));
_extend(dt, require("./lmv-compat/DtLightPresets"));
_extend(dt, require("./lmv-compat/ui/DtProgressBar"));

const i18init = require("./globalization/i18init");
_extend(dt, i18init);
const i18n = i18init.i18n;
i18n.translate = i18n.t.bind(i18n);
i18n.localize = () => {};
_extend(dt, {i18n});

// Apply LMV patches
require("./lmv-compat/patches/RenderBatchPatch");
require("./lmv-compat/patches/MultiModelVisibilityManagerPatch.js");
require("./lmv-compat/patches/ScreenShotPatch.js");
